import { FC } from "react";

interface MapIconSVGProps {
    className?: string;
}

const MapIconSVG: FC<MapIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M27.5 10.567C26.9311 10.567 26.3699 10.4346 25.861 10.1803L18.139 6.31933C17.6301 6.06501 17.0689 5.93262 16.5 5.93262M27.5 10.567C28.0689 10.567 28.6301 10.4346 29.139 10.1803L35.8472 6.82533C36.1269 6.68555 36.4377 6.61964 36.7501 6.63387C37.0625 6.64809 37.366 6.74198 37.6318 6.9066C37.8977 7.07122 38.117 7.3011 38.269 7.57439C38.4209 7.84768 38.5005 8.1553 38.5 8.46799V31.8687C38.4998 32.209 38.4049 32.5426 38.2258 32.8321C38.0468 33.1216 37.7907 33.3555 37.4862 33.5077L29.139 37.6822C28.6301 37.9365 28.0689 38.0689 27.5 38.0689C26.9311 38.0689 26.3699 37.9365 25.861 37.6822L18.139 33.8212C17.6301 33.5668 17.0689 33.4345 16.5 33.4345C15.9311 33.4345 15.3699 33.5668 14.861 33.8212L8.15284 37.1762C7.87298 37.316 7.562 37.3819 7.24948 37.3676C6.93695 37.3533 6.63329 37.2592 6.36739 37.0944C6.10148 36.9296 5.88218 36.6994 5.73036 36.4259C5.57853 36.1523 5.49923 35.8445 5.50001 35.5317V12.1328C5.50019 11.7924 5.59512 11.4588 5.77418 11.1694C5.95325 10.8799 6.20936 10.646 6.51384 10.4938L14.861 6.31933C15.3699 6.06501 15.9311 5.93262 16.5 5.93262M27.5 10.567V38.0672M16.5 5.93262L16.5 33.4325"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default MapIconSVG;
